// React imports.
import * as React from 'react';

/**
 * Stateless functional components, renders a loading component.
 *
 * @param props The propagated properties.
 * @returns {JSX.Element} The element that needs to be rendered.
 */
const Loading = (props: {}): JSX.Element => (
  <div className="loading">
    <div className="loading__pulse" />
    <div className="loading__text">Loading...</div>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.tsx